module.exports = __webpack_public_path__ + "assets/116d8917e1311e0ca32dcab8bcbfd2e1.mp3";